import React from 'react';

import { ReactComponent as ImageDropCircleIcon } from '../../../../assets/img/icons/image-drop-circle.svg';
import { ReactComponent as ImageDropPlusIcon } from '../../../../assets/img/icons/image-drop-plus.svg';
import DropArea from './DropArea';

export default (options, { handle }) => (
  <DropArea>
    {(isDrag) => (
      <div className={`rug-handle ${isDrag ? '__dragging' : ''}`} onClick={options.openDialogue}>
        <div className="rug-handle-info">
          {typeof handle === 'function' ? (
            handle(options)
          ) : (
            <React.Fragment>
              <div className="rug-image-drop-icon-wrapper">
                <ImageDropCircleIcon className="rug-image-drop-circle-icon" />
                <ImageDropPlusIcon className="rug-image-drop-plus-icon" />
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    )}
  </DropArea>
);
